import { render, staticRenderFns } from "./CreateReservationForm.vue?vue&type=template&id=3b83149a"
import script from "./CreateReservationForm.vue?vue&type=script&lang=js"
export * from "./CreateReservationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports